<div class="modal-container">

  <div class="modal-header">
    <div class="modal-toolbar">
      <div class="modal-title">
        <div>
          <div>Freshness Indicator Explanation</div>
          <span></span>
          <app-shared-button [fill]="false" colour="clear" (click)="onButtonPress()">
            <app-display-icon [icon]="icons.close"></app-display-icon>
          </app-shared-button>
        </div>
      </div>
    </div>
  </div>

  <div class="app-content">
    <div>
      <p>
        <span
          class="header">How does Gallix work and what do the different coloured dots next to the store name mean?</span>
        <br>
        This flow chart shows how Gallix interacts with your server and explains what the different colors of the
        data freshness indicators mean.
        <br>
        Remember, a red light doesn't mean your server is disconnected from Gallix. It simply means the data you are
        viewing is old. You can still use Gallix, and all actions will be processed when it is online.
        <br>
        If the light is red and you need the latest stock information, refresh the page to force an update. If the light
        stays red for more than two minutes, please contact us.
        <br>
        If the server is offline, your actions will be queued and processed as soon as the connection is restored.
      </p>
    </div>


    @if (isImageLoading) {
      <div class="loading-indicator">
        <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
      </div>
    }
    <div class="img-div">
      @if (imageUrl) {
        <img
          [ngSrc]="imageUrl"
          alt="Gallix Flow Chart"
          width="785"
          height="416"
          (load)="onImageLoad()"/>
      }
    </div>
  </div>

</div>
